import { inject, Injectable } from '@angular/core';
import { ConsultOption, EConsultOptionEntity, ListConsultOptionsGQL } from '@insolution/graphql-data-access';
import { ELanguage } from '@insolution/shared-data-access';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConsultOptionService {
  private listConsultOptionsGQL = inject(ListConsultOptionsGQL);

  public async getConsultOptions(language: ELanguage): Promise<ConsultOption[]> {
    const consultOptions = await firstValueFrom(this.listConsultOptionsGQL.fetch({ language }));
    return consultOptions.data.listConsultOptions;
  }

  public async getConsultOptionsByEntity(language: ELanguage, entity: EConsultOptionEntity): Promise<ConsultOption[]> {
    const result = await this.getConsultOptions(language);
    return result
      .slice()
      .filter((option) => option.entity === entity)
      .sort((a, b) => a.rank - b.rank);
  }
}
